import React from 'react';
import { Link } from 'react-router-dom';
import { 
    FaTruck, FaRupeeSign, FaShieldAlt, FaHeadphones, 
    FaFacebook, FaLinkedin, FaTwitter, FaInstagram, 
    FaGooglePlay, FaApple, FaMapMarkerAlt, FaHeart 
} from 'react-icons/fa';

const B2BHaartModernFooter: React.FC = () => {
    // Theme Styles
    const footerBg = 'bg-[#1e293b]'; // Dark Navy Blue
    const accentOrange = 'text-frogOrange'; 
    const baseBg = 'bg-gray-100'; 

    // Icon Style: Green color fix
    const iconStyle = "text-orange-600 text-3xl mt-1 flex-shrink-0"; 

    return (
        // Added 'mt-16' to create space above the footer
        <footer className="font-sans pt-0 mt-16">
            
            {/* --- Top Benefits Bar --- */}
            <div className={`py-10 text-gray-800 border-b border-gray-200 ${baseBg}`}>
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-5 md:gap-0 gap-y-8">
                    
                    {/* Item 1 */}
                    <div className="flex items-start space-x-3 md:border-r md:border-gray-300 md:pr-4">
                        <FaRupeeSign className={iconStyle} />
                        <div>
                            <h3 className="text-lg font-bold">Great Value</h3>
                            <p className="text-sm text-gray-600">Most popular brands with widest range of selection.</p>
                        </div>
                    </div>

                    {/* Item 2 */}
                    <div className="flex items-start space-x-3 md:border-r md:border-gray-300 md:px-4">
                        <FaTruck className={iconStyle} />
                        <div>
                            <h3 className="text-lg font-bold">Nationwide Delivery</h3>
                            <p className="text-sm text-gray-600">Over 20,000 pincodes serviceable across India.</p>
                        </div>
                    </div>

                    {/* Item 3 */}
                    <div className="flex items-start space-x-3 md:border-r md:border-gray-300 md:px-4">
                        <FaShieldAlt className={iconStyle} />
                        <div>
                            <h3 className="text-lg font-bold">Secure Payment</h3>
                            <p className="text-sm text-gray-600">Secure payment methods available.</p>
                        </div>
                    </div>

                    {/* Item 4 */}
                    <div className="flex items-start space-x-3 md:border-r md:border-gray-300 md:px-4">
                        <FaHeart className={iconStyle} />
                        <div>
                            <h3 className="text-lg font-bold">Buyer Protection</h3>
                            <p className="text-sm text-gray-600">Committed to buyer interests for smooth shopping.</p>
                        </div>
                    </div>

                    {/* Item 5 */}
                    <div className="flex items-start space-x-3 md:pl-4">
                        <FaHeadphones className={iconStyle} />
                        <div>
                            <h3 className="text-lg font-bold">365 Days Help Desk</h3>
                            <p className="text-sm text-gray-600 font-semibold">Call Us: +91 9660660070</p>
                            <p className="text-xs text-gray-500">Email: care@b2bhaart.com</p>
                        </div>
                    </div>

                </div>
            </div>

            {/* --- Main Footer --- */}
            <div className={`${footerBg} text-white py-10`}>
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
                    
                    {/* 1. Left Section (Address at TOP) */}
                    <div className="col-span-1 lg:col-span-2 pr-4">
                        <div className="flex items-start mb-5">
                             <FaMapMarkerAlt className="text-frogOrange mr-3 mt-1 text-2xl flex-shrink-0" />
                             <div>
                                 <h4 className="text-lg font-bold text-white leading-tight"><span className='text-orange-600'>TradyFrog</span> (India) Pvt. Ltd.</h4>
                                 <p className="text-sm text-gray-400 mt-1">New Delhi, India</p>
                             </div>
                        </div>
                        <p className="text-sm text-gray-300 mb-6 leading-relaxed">
                            India's largest TradyFrog e-commerce platform for industrial products and digital procurement solutions. 
                        </p>
                        <div className="flex space-x-4 mb-2">
                            <a href="#" className="text-xl hover:text-orange-600 transition-colors"><FaFacebook /></a>
                            <a href="#" className="text-xl hover:text-orange-600 transition-colors"><FaLinkedin /></a>
                            <a href="#" className="text-xl hover:text-orange-600 transition-colors"><FaInstagram /></a>
                            {/* <a href="#" className="text-xl hover:text-orange-400 transition-colors"><FaTwitter /></a> */}
                        </div>
                    </div>
                    
                    {/* 2. COMPANY */}
                    <div className="lg:col-span-1">
                        <h4 className={`text-lg font-bold mb-4 ${accentOrange}`}>COMPANY</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                            <li><Link to="/press" className="hover:text-white transition-colors">Press</Link></li>
                            <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                            <li><Link to="/faqs" className="hover:text-white transition-colors">FAQs</Link></li>
                            <li><Link to="/articles" className="hover:text-white transition-colors">Articles</Link></li>
                        </ul>
                    </div>
                    
                    {/* 3. HELP CENTER */}
                    <div className="lg:col-span-1">
                        <h4 className={`text-lg font-bold mb-4 ${accentOrange}`}>HELP CENTER</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
                            <li><Link to="/track-order" className="hover:text-white transition-colors">Order Tracking</Link></li>
                            <li><Link to="/cancellation-policy" className="hover:text-white transition-colors">Cancellation & Return</Link></li>
                            <li><Link to="/payment" className="hover:text-white transition-colors">Payment Option</Link></li>
                        </ul>
                    </div>

                    {/* 4. SOURCING */}
                    <div className="lg:col-span-1">
                        <h4 className={`text-lg font-bold mb-4 ${accentOrange}`}>SOURCING</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li><Link to="/popular-searches" className="hover:text-white transition-colors">Popular Searches</Link></li>
                            <li><a href="#" className="hover:text-white transition-colors">Best Deals</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Industry Store</a></li>
                        </ul>
                    </div>

                    {/* 5. PARTNER */}
                    <div className="lg:col-span-1">
                        <h4 className={`text-lg font-bold mb-4 ${accentOrange}`}>PARTNER</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li><a href="#" className="hover:text-white transition-colors">Bulk Enquiry</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Supplier Central</a></li>
                        </ul>
                    </div>

                    {/* 6. DOWNLOAD APP */}
                    <div className="lg:col-span-1">
                        <h4 className={`text-lg font-bold mb-4 ${accentOrange}`}>APP</h4>
                        <div className="space-y-2">
                            <a href="#" className="flex items-center justify-center px-3 py-2 border border-gray-500 rounded-lg hover:bg-white hover:text-black transition duration-300 w-full">
                                <FaApple className="text-xl mr-2" />
                                <div className="text-left leading-tight">
                                    <p className="text-[10px] uppercase">Download on</p>
                                    <p className="text-xs font-bold">App Store</p>
                                </div>
                            </a>
                            <a href="#" className="flex items-center justify-center px-3 py-2 border border-gray-500 rounded-lg hover:bg-white hover:text-black transition duration-300 w-full">
                                <FaGooglePlay className="text-xl mr-2" />
                                <div className="text-left leading-tight">
                                    <p className="text-[10px] uppercase">Get it on</p>
                                    <p className="text-xs font-bold">Google Play</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- Bottom Copyright --- */}
            <div className="bg-[#0f172a] py-4 text-center text-sm text-slate-400 border-t border-slate-800">
                <p>Terms of Use | Copyright | Privacy Policy | Compliance | &copy; 2024 B2BHAART LABS (INDIA) PRIVATE LIMITED.</p>
            </div>
        </footer>
    );
};

export default B2BHaartModernFooter;